var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_61261",
    "data-name": "Group 61261",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140.713,
    height: 48.35,
    viewBox: "0 0 140.713 48.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22608",
    "data-name": "Rectangle 22608",
    width: 140.713,
    height: 48.349,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61258",
    "data-name": "Group 61258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61257",
    "data-name": "Group 61257",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82261",
    "data-name": "Path 82261",
    d: "M200.35,85.01a2.5,2.5,0,0,1,.744-1.813,2.424,2.424,0,0,1,1.8-.759,2.45,2.45,0,0,1,1.8.744,2.487,2.487,0,0,1,.744,1.828,2.415,2.415,0,0,1-.744,1.766,2.544,2.544,0,0,1-3.594,0,2.412,2.412,0,0,1-.744-1.766m4.616,20.232h-4.12V90h4.12Z",
    transform: "translate(-139.171 -57.264)",
    fill: "#edffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82262",
    "data-name": "Path 82262",
    d: "M235.012,112.756v8.768h-4.12V106.28h4v1.89a4.25,4.25,0,0,1,1.86-1.7,5.726,5.726,0,0,1,2.54-.589,5.046,5.046,0,0,1,4.106,1.688,6.567,6.567,0,0,1,1.41,4.353v9.6h-4.121v-8.893a3.325,3.325,0,0,0-.7-2.2,2.973,2.973,0,0,0-4.2.062,3.34,3.34,0,0,0-.775,2.262",
    transform: "translate(-160.386 -73.547)",
    fill: "#edffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82263",
    "data-name": "Path 82263",
    d: "M303.086,83.656v19.675q0,1.518.124,2.757h-3.935a9.059,9.059,0,0,1-.155-1.766,3.844,3.844,0,0,1-1.658,1.549,5.594,5.594,0,0,1-2.618.589,6.936,6.936,0,0,1-5.345-2.277,8.889,8.889,0,0,1-.031-11.418,6.75,6.75,0,0,1,5.252-2.293q3.284,0,4.307,1.89V83.656ZM291.56,98.435a4.55,4.55,0,0,0,1.053,3.176,3.51,3.51,0,0,0,2.726,1.162,3.456,3.456,0,0,0,2.7-1.177,4.613,4.613,0,0,0,1.053-3.191,4.393,4.393,0,0,0-1.053-3.114,3.778,3.778,0,0,0-5.407.016,4.408,4.408,0,0,0-1.069,3.129",
    transform: "translate(-199.644 -58.111)",
    fill: "#edffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82264",
    "data-name": "Path 82264",
    d: "M353.891,144.178a2.807,2.807,0,0,1,0-4,2.738,2.738,0,0,1,1.983-.821,2.773,2.773,0,0,1,2.014.821,2.805,2.805,0,0,1,0,4,2.772,2.772,0,0,1-2.014.821,2.737,2.737,0,0,1-1.983-.821",
    transform: "translate(-245.245 -96.805)",
    fill: "#edffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82265",
    "data-name": "Path 82265",
    d: "M384.709,85.01a2.5,2.5,0,0,1,.744-1.813,2.424,2.424,0,0,1,1.8-.759,2.448,2.448,0,0,1,1.8.744,2.487,2.487,0,0,1,.744,1.828,2.415,2.415,0,0,1-.744,1.766,2.543,2.543,0,0,1-3.594,0,2.413,2.413,0,0,1-.744-1.766m4.616,20.232H385.2V90h4.12Z",
    transform: "translate(-267.233 -57.264)",
    fill: "#edffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82266",
    "data-name": "Path 82266",
    d: "M419.371,112.756v8.768h-4.12V106.28h4v1.89a4.25,4.25,0,0,1,1.86-1.7,5.726,5.726,0,0,1,2.54-.589,5.046,5.046,0,0,1,4.106,1.688,6.567,6.567,0,0,1,1.409,4.353v9.6h-4.121v-8.893a3.325,3.325,0,0,0-.7-2.2,2.973,2.973,0,0,0-4.2.062,3.34,3.34,0,0,0-.775,2.262",
    transform: "translate(-288.449 -73.547)",
    fill: "#edffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82267",
    "data-name": "Path 82267",
    d: "M153.366,15.217h-3.935v8.273h-4.276V1.522h8.211a7.22,7.22,0,0,1,5.22,1.921,6.534,6.534,0,0,1,2,4.926,6.531,6.531,0,0,1-2,4.926,7.216,7.216,0,0,1-5.22,1.921m-3.9-3.687h3.377a3.572,3.572,0,0,0,2.509-.852,2.94,2.94,0,0,0,.93-2.277,3,3,0,0,0-.914-2.308,3.561,3.561,0,0,0-2.525-.852h-3.377Z",
    transform: "translate(-100.83 -1.057)",
    fill: "#edffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82268",
    "data-name": "Path 82268",
    d: "M210.053,13.478v8.954h-4.12V0h4.12V8.459a5.058,5.058,0,0,1,4.121-1.673,5.253,5.253,0,0,1,4.23,1.688,6.474,6.474,0,0,1,1.44,4.353v9.6h-4.121V13.54a3.325,3.325,0,0,0-.7-2.2,2.993,2.993,0,0,0-4.152,0,3.3,3.3,0,0,0-.821,2.138",
    transform: "translate(-143.049)",
    fill: "#edffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82269",
    "data-name": "Path 82269",
    d: "M264.723,24.31a8.272,8.272,0,0,1,11.433,0,7.881,7.881,0,0,1,2.278,5.794,7.879,7.879,0,0,1-2.278,5.794,8.272,8.272,0,0,1-11.433,0,7.881,7.881,0,0,1-2.277-5.794,7.883,7.883,0,0,1,2.277-5.794M267.7,33.3a3.853,3.853,0,0,0,5.484,0,4.349,4.349,0,0,0,1.131-3.191,4.351,4.351,0,0,0-1.131-3.191,3.853,3.853,0,0,0-5.484,0,4.348,4.348,0,0,0-1.13,3.191A4.347,4.347,0,0,0,267.7,33.3",
    transform: "translate(-182.305 -15.294)",
    fill: "#edffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82270",
    "data-name": "Path 82270",
    d: "M327.331,8.625v4.554H330.4v3.656h-3.067v6.382a1.8,1.8,0,0,0,.434,1.363,1.957,1.957,0,0,0,1.363.4,4.913,4.913,0,0,0,1.27-.124v3.408a6.145,6.145,0,0,1-2.324.372,4.874,4.874,0,0,1-3.532-1.255,4.575,4.575,0,0,1-1.3-3.455v-7.1h-2.757V13.179h.774a2.244,2.244,0,0,0,1.751-.666,2.5,2.5,0,0,0,.6-1.751V8.625Z",
    transform: "translate(-222.62 -5.991)",
    fill: "#edffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82271",
    "data-name": "Path 82271",
    d: "M363.448,24.31a8.272,8.272,0,0,1,11.433,0,7.882,7.882,0,0,1,2.278,5.794,7.88,7.88,0,0,1-2.278,5.794,8.272,8.272,0,0,1-11.433,0,7.881,7.881,0,0,1-2.277-5.794,7.883,7.883,0,0,1,2.277-5.794m2.975,8.985a3.853,3.853,0,0,0,5.484,0,4.35,4.35,0,0,0,1.131-3.191,4.351,4.351,0,0,0-1.131-3.191,3.853,3.853,0,0,0-5.484,0,4.348,4.348,0,0,0-1.13,3.191,4.347,4.347,0,0,0,1.13,3.191",
    transform: "translate(-250.883 -15.294)",
    fill: "#edffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82272",
    "data-name": "Path 82272",
    d: "M31.753,13.715v2.968H18.647a2.733,2.733,0,0,0-2.733,2.733V32.559H0V13.715A12.946,12.946,0,0,1,12.946.769h5.861A12.946,12.946,0,0,1,31.753,13.715",
    transform: "translate(0 -0.534)",
    fill: "#6711ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82273",
    "data-name": "Path 82273",
    d: "M15.914,104.876v2.893A12.946,12.946,0,0,1,2.968,120.715H0v-15.84Z",
    transform: "translate(0 -72.851)",
    fill: "#00b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82274",
    "data-name": "Path 82274",
    d: "M67.954,52.883v2.893A12.946,12.946,0,0,1,55.008,68.722H52.115V55.616a2.733,2.733,0,0,1,2.733-2.733Z",
    transform: "translate(-36.201 -36.734)",
    fill: "#00eaaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82275",
    "data-name": "Path 82275",
    d: "M149.462,107.146h-4.307V85.178h13.881v4.059h-9.6v5.422h8.551v3.935h-8.521Z",
    transform: "translate(-100.83 -59.168)",
    fill: "#e7f9f9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.5526de4e1844123ebe880d0cac135121.svg";
export { ForwardRef as ReactComponent };